import { useTranslation } from "react-i18next";
import { Grid, GridColumn, GridRow } from "semantic-ui-react";

import "modules/AppointmentDetails/components/Interventions/components/PinOverview/components/PinSection/PinSection.scss";

import type { DropdownItemProps } from "components";
import type { PIN_STATUSES, Pin } from "models";

type Props = {
  pin?: Pin;
  pinStatusOptions: DropdownItemProps<PIN_STATUSES>[];
};

export const PinSection = ({ pin, pinStatusOptions }: Props) => {
  const { t } = useTranslation();

  if (!pinStatusOptions.length || !pin) return null;

  const pinStatus = pinStatusOptions.find(pinElement => pinElement.value === pin.pin_status_id);

  return (
    <div className="PinSectionContent">
      <div className="pin-section">
        <Grid columns="equal" padded="horizontally" className="grid-header-container">
          <GridRow verticalAlign="middle">
            <GridColumn>
              <span className="grid-title-text"> {`${t("v8_support")} #` || "Support #"} </span>
            </GridColumn>
            <GridColumn>
              <span className="grid-title-text"> {`${t("v8_claim")} #` || "Claim #"}</span>
            </GridColumn>
            <GridColumn>
              <span className="grid-title-text"> {t("v8_reference", "Reference")} </span>
            </GridColumn>
            <GridColumn>
              <span className="grid-title-text">{t("v8_status", "Status")}</span>
            </GridColumn>
          </GridRow>
        </Grid>
        <Grid columns="4" padded="horizontally" className="results-grid">
          <GridRow verticalAlign="middle">
            <GridColumn>
              <span className="grid-field-text">{pin.support_nr} </span>
            </GridColumn>
            <GridColumn>
              <span className="grid-field-text">{pin.claim_nr} </span>
            </GridColumn>
            <GridColumn>
              <span className="grid-field-text">{pin.ref_nr}</span>
            </GridColumn>
            <GridColumn>{pinStatus && <span className="grid-field-text">{pinStatus.text}</span>}</GridColumn>
          </GridRow>
        </Grid>
      </div>
    </div>
  );
};
